/* VCTparts: kleine productpagina-laag (geladen vanuit sections/main-product.liquid).
   Mobiel staat de titel op twee regels (assets/vct-pdp.css); tik erop voor de
   hele titel. Alleen als de titel ook echt is afgekapt. */
(function () {
  function init() {
    var h1 = document.querySelector('#main-product > header.mobile-only h1');
    if (!h1) return;
    h1.addEventListener('click', function () {
      if (!h1.classList.contains('is-open') && h1.scrollHeight <= h1.clientHeight + 1) return;
      h1.classList.toggle('is-open');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
